import { render, staticRenderFns } from "./DistributionFormGroup.vue?vue&type=template&id=8161d9fa&scoped=true&"
import script from "./DistributionFormGroup.vue?vue&type=script&lang=js&"
export * from "./DistributionFormGroup.vue?vue&type=script&lang=js&"
import style0 from "./DistributionFormGroup.vue?vue&type=style&index=0&id=8161d9fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8161d9fa",
  null
  
)

export default component.exports